const $ = global.$ || global.jQuery || require('jquery');

/**
 * A View responsible for updating the DatasetSelector.
 */
export default class DatasetSelectorComponent {

  /**
   * Constructor.
   */
  constructor(datasetModel) {

    // Capture the reference to the Model.
    this._datasetModel = datasetModel;

    // Capture the reference to the underlying selector.
    this.$el = $('#dataset-selector');

    // Handle changes to the Dataset model (ie: change to active Dataset).
    this._datasetModel.on(this._datasetModel.VALUE_CHANGED_EVENT, this.handleDatasetModelChange.bind(this));

    // Handle user selecting a different Dataset.
    this.$el.change(this.handleOnChangeEvent.bind(this));

    // Render the component.
    this._render();
  }

  /**
   * Private method to render the component. For this component, this method is expected to be
   * called only once, during instantiation/initialisation.
   */
  _render() {

    // Make sure the DOM object is empty.
    this.$el.empty();

    // Re-populate with the list.
    this._datasetModel.getAvailableDatasets().forEach(function(dataset) {
      this.$el.append(
        `<option value="${dataset.id}">${dataset.title}</option>`
      );
    }, this);

    this._selectItem();

  };

  /**
   * Private method to set the 'selected' property on the appropriate item in the component.
   */
  _selectItem() {

    // De-select all entries.
    this.$el.find('option').removeProp('selected');

    // Select the current entry, if any.
    const dataset = this._datasetModel.getActiveDataset();
    if (dataset) {
      this.$el.find(`option[value="${dataset.id}"]`).prop('selected', true);
    }

  }

  /**
   * Handler invoked when the DatasetModel emits a change event.
   */
  handleDatasetModelChange() {
    // Do nothing.
  }

  /**
   * Handler invoked when the user makes a selection from the component.
   */
  handleOnChangeEvent(event) {
    const id = $(event.currentTarget).val();
    const selection = this._datasetModel.getAvailableDatasets().find(function(dataset) {
      return dataset.id == id;
    }.bind(this));
    this._datasetModel.setActiveDataset(selection);
  }

  toggle() {
    this.$el.toggle();
  }

}



// WEBPACK FOOTER //
// ./src/app/map/dataset-selector/component.js